
import { ProductType } from '@/types'
import Vue from 'vue'
import { formatOneDecimal } from '@/common/utils/common'
import BaseImage from '@/common/components/BaseImage.vue'
import PrintTag from '@/common/components/PrintTag.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import FavoriteBtn from '@/common/components/FavoriteBtn.vue'
import { IMAGE_VARIANT } from '@/common/const'

export default Vue.extend({
  components:{
    BaseImage,
    PrintTag,
    FavoriteBtn
  },
  props: {
    product: {
      type: Object as () => ProductType,
      required: true
    }
  },
  data(): {
    isMounted: boolean,
  } {
    return {
      isMounted: false
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    IMAGE_VARIANT() {
      return IMAGE_VARIANT.PRODUCT
    }
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    formatOneDecimal,
    onClickProduct(id: string) {
      this.$emit('onClickProduct', id)
    }
  }
})
